import { getSiteData } from '../utils/get-site-data'

class FsnStats {
  constructor() {
    this.baseUrl = `http://global.fsnservice.com/api`
    this.proxyUrl = `https://api.fsnservice.com`
  }

  async fetchTournamentSchedule({ tournamentId, site }) {
    const response = await fetch(
      `${this.proxyUrl}/soccer/tournaments/${tournamentId}/matches`,
      {
        headers: this._getHeaders(site),
      }
    )
    return await response.json()
  }

  async getMatch({ matchId, site }) {
    const response = await fetch(`${this.proxyUrl}/soccer/match/${matchId}`, {
      headers: this._getHeaders(site),
    })
    return await response.json()
  }

  _getHeaders(site = 'BUS') {
    const { timezone, lang } = getSiteData(site)
    return {
      'x-site-code': site,
      'x-tz': timezone,
      'x-lang': lang,
    }
  }
}

export { FsnStats }
